module.exports = __webpack_public_path__ + "static/media/plus.baf01fb9.svg";